import { Label } from '@nimbus-ds/components';
import { Stack, RadioButtonGroup } from 'commons/components';
import { Categories } from 'domains/Marketing/components';
import { useTranslationMarketing } from 'domains/Marketing/hook';
import { SelectionModes } from './types';

export function CategoriesSelector({
  categories,
  categoriesType,
  onChange,
  onChangeCategories,
}) {
  const t = useTranslationMarketing('freeShipping');

  return (
    <>
      <RadioButtonGroup
        name="categoriesType"
        value={categoriesType}
        onChange={({ value }) =>
          onChange({ target: { name: 'categoriesType', value } })
        }
        options={[
          {
            label: t('asides.categories.all.label'),
            value: SelectionModes.ALL,
          },
          {
            label: t('asides.categories.some.label'),
            value: SelectionModes.SOME,
          },
        ]}
      />
      {categoriesType === SelectionModes.ALL && (
        <Stack column align="stretch">
          <Stack.Item>
            <Label>{t('asides.categories.all.description')}</Label>
          </Stack.Item>
        </Stack>
      )}
      {categoriesType === SelectionModes.SOME && (
        <Stack column align="stretch">
          <Stack.Item>
            <Label>{t('asides.categories.some.description')}</Label>
          </Stack.Item>
          <Stack.Item>
            <Categories
              categories={categories}
              emptyTitle={t('asides.categories.empty.title')}
              emptyText={t('asides.categories.empty.text')}
              ctaText={t('asides.categories.empty.ctaText')}
              onChange={onChangeCategories}
              showTitle={false}
              selectLinkText={t('asides.categories.selector.select')}
              editLinkText={t('asides.categories.selector.edit')}
              subtitle={t('asides.categories.selector.description')}
            />
          </Stack.Item>
        </Stack>
      )}
    </>
  );
}
